import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { batchRequest } from '../../../../api/ApiService';
import { Loader } from "react-loaders";

import Image1 from '../../../../containers/assets/onboarding-gameoverview-image1.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
  text-align: left;

  .loader {
    display: inline-block;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    font-weight: 500;
    color: #ed716d;

    &.green-total {
      color: #2da548;
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
  position: relative;
`;

const ImageText = styled.div`
  position: absolute;
  top: 58px;
  left: 518px;

  font-family: 'Mukta Malar';
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 60px;
  color: #ffffff;

  transform: matrix(0.98, 0.19, -0.2, 0.98, 0, 0);
`;

class GameOverviewStep1 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    const { currentRound } = this.props;

    batchRequest([
      `${process.env.REACT_APP_API_URL}static/customer_preferences/`,
      `${process.env.REACT_APP_API_URL}static/customer_demand/`,
    ])
      .then(res => {
        const customerPreferences = res[0].body;
        const maxPrices = customerPreferences
          .filter(i => i.round_number === currentRound);

        const customerDemand = res[1].body;
        const demands = customerDemand
          .filter(i => i.round_number === currentRound);
        const total = maxPrices.reduce((prev, obj) => {
          const customer = Number(obj.customer);
          const maxPrice = obj.max_price ? Number(obj.max_price) : 0;
          const demandObject = demands.find(i => Number(i.customer) === customer);
          const demand = demandObject ? Number(demandObject.demand) : 0;

          return prev + maxPrice * demand;
        }, 0);

        this.setState({
          total: (total / 1000000).toFixed(0),
          loading: false,
        });
      })
      .catch(err => {});
  }

  render() {
    const { loading, total } = this.state;

    return loading ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : (
      <Wrapper>
        <Text1>Game Overview</Text1>
        <Text2>The Market Opportunity</Text2>
        <Text3>
          The exercise starts with your students conducting market research to explore
          a <b className="green-total">${total}M</b> and growing market opportunity in the <b>image sensor</b> market.
        </Text3>
        <Image>
          <img src={Image1} alt="" />
          <ImageText>${total}M</ImageText>
        </Image>
        <Text3>
          They'll <b>review a Business Case</b> and <b>Analyze Customer preferences</b> to a gain
          a better understanding of who to serve and how to enter the market.
        </Text3>
      </Wrapper>
    );
  }

}

export default GameOverviewStep1;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/game-overview/step1.js